import { strictParseInt } from '../lib/number.no-deps'

export const ports = {
    api: strictParseInt(process.env.API_PORT) ?? 1330,
    camelotAPI: 6666,
    metadataTest: 1331,
    portal: strictParseInt(process.env.PORTAL_PORT) ?? strictParseInt(process.env.PORT) ?? 8000,
    websocket: strictParseInt(process.env.WEBSOCKET_PORT) ?? 1338,
    auth: strictParseInt(process.env.AUTH_PORT) ?? strictParseInt(process.env.PORT) ?? 7000,
    app: strictParseInt(process.env.APP_PORT) ?? 3456,
    appWebpackDevServer: 9000,
}
